import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";

import prevButton from "../../img/prevb.svg";
import nextButton from "../../img/nextb.svg";
import cardImg1 from "../../img/AboutUs/sw/sw1.webp";
import cardImg2 from "../../img/AboutUs/sw/sw2.webp";
import cardImg3 from "../../img/AboutUs/sw/sw3.webp";
import cardImg4 from "../../img/AboutUs/sw/sw4.webp";
import cardImg5 from "../../img/AboutUs/sw/sw5.webp";
import cardImg6 from "../../img/AboutUs/sw/sw6.webp";
import Fade from 'react-reveal/Fade';

const features = [
  { img: cardImg1, titleKey: "about.features.1.title", textKey: "about.features.1.text" },
  { img: cardImg2, titleKey: "about.features.2.title", textKey: "about.features.2.text" },
  { img: cardImg3, titleKey: "about.features.3.title", textKey: "about.features.3.text" },
  { img: cardImg4, titleKey: "about.features.4.title", textKey: "about.features.4.text" },
  { img: cardImg5, titleKey: "about.features.5.title", textKey: "about.features.5.text" },
  { img: cardImg6, titleKey: "about.features.6.title", textKey: "about.features.6.text" },
];

function AdvancedFeatures() {
  
  const { t } = useTranslation();
  const swiperRef = useRef(null);

  return (
    <section className="mt-[80px] xl:mt-[160px]">
      <div className="mx-auto max-w-[1220px] px-[20px] xl:px-0">
        {/* Title */}
        <Fade bottom>
        <div className="flex flex-col items-center gap-[15px]">
          <h2 className="font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#3273b4] xl:text-[32px]">
            {t("about.features.title")}
          </h2>
          <span className="block h-[4px] w-[104px] bg-[#05193a]" />
        </div>
        </Fade>

        {/* Slider */}
        <Fade bottom delay={200}>
        <div className="mt-[40px]">
          <Swiper
            modules={[Navigation]}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            spaceBetween={20}
            slidesPerView={1}
            grabCursor
            breakpoints={{
              1024: { slidesPerView: 3, spaceBetween: 36 },
              640: { slidesPerView: 2, spaceBetween: 20 },
            }}
          >
            {features.map((feature, i) => (
              <SwiperSlide key={i} className="!h-auto">
                <div className="flex h-full flex-col bg-[#daebfc]">
                  <div className="h-[199px] w-full overflow-hidden">
                    <img
                      src={feature.img}
                      alt={t(feature.titleKey)}
                      className="h-full w-full object-cover"
                    />
                  </div>
                  <div className="px-[21px] pb-[35px] pt-[20px]">
                    <p className="font-['Nunito_Sans'] text-[16px] font-black leading-[1.4] text-[#05193a]">
                      {t(feature.titleKey)}
                    </p>
                    <p className="mt-[10px] font-['Nunito_Sans'] text-[16px] font-light leading-[1.4] text-[#05193a]">
                      {t(feature.textKey)}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        </Fade>

        {/* Navigation */}
        <div className="mt-[24px] flex justify-end gap-[10px]">
          <button
            type="button"
            aria-label="Previous"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <img src={prevButton} alt="" className="h-[42px] w-[42px] xl:h-[52px] xl:w-[52px]" />
          </button>
          <button
            type="button"
            aria-label="Next"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <img src={nextButton} alt="" className="h-[42px] w-[42px] xl:h-[52px] xl:w-[52px]" />
          </button>
        </div>
      </div>
    </section>
  );
}

export default AdvancedFeatures;
